import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'
import { Project } from '@/types/projects'

export async function getProjects(
  companyId: number,
  userId: number,
  signal?: AbortSignal,
) {
  const { data } = await companiesApi.get<Project[]>(
    apiRoutes.getProjectsByFather(companyId),
    {
      params: {
        userId,
      },
      signal,
    },
  )

  return data
}
